import { Component, Injector } from '@angular/core';
import {
  MessageService,
  LoaderService,
  ValidationResultService,
} from '@shared';
import { CategoryService } from '@shared-data';
import { GridRowBundleChangeset } from '../../models';
import { RestaurantItemService } from '../../services';
import { BasePricingChangesetComponent } from '../base-pricing-changeset/base-pricing-changeset.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-bundle-changeset',
  templateUrl: './bundle-changeset.component.html',
  styleUrl: './bundle-changeset.component.scss',
})
export class BundleChangesetComponent extends BasePricingChangesetComponent {
  constructor(
    validationErrorService: ValidationResultService,
    messageService: MessageService,
    loaderService: LoaderService,
    categoryService: CategoryService,
    restaurantItemsService: RestaurantItemService,
    activatedRoute: ActivatedRoute,
    injector: Injector,
  ) {
    super(
      validationErrorService,
      messageService,
      loaderService,
      restaurantItemsService,
      categoryService,
      activatedRoute,
      injector,
      GridRowBundleChangeset,
    );
  }

  // The sub-selector holds a bundle instead of a category, so the value
  // selected on the toolbar filters the grid by the bundle container id
  protected override getSubSelectorFilterField(): string {
    return 'comboParId';
  }

  // A bundle holds more components than a page of the other grids fits, so the
  // whole of the smaller ones is on screen without paging
  protected override getPageSize(): number {
    return 20;
  }

  // Sorted by the bundle sort_order first (so Whopper comes before Dbl before
  // Impossible), then by component type id (Entrée, Sides, Drinks), then
  // defaults before substitutions, then alphabetically by component name
  override setInitialSort(): void {
    this.initialSort = [
      { field: 'sortOrder', dir: 'asc' },
      { field: 'comboName', dir: 'asc' },
      { field: 'componentRole', dir: 'asc' },
      { field: 'componentTypeId', dir: 'asc' },
      { field: 'componentName', dir: 'asc' },
    ];
  }

  override setInitialFilter(): void {
    // Bundles show every component regardless of the active flags, so the
    // inactive ones can be reviewed too. Both flags are filterable columns.
    this.initialFilter = {
      logic: 'and',
      filters: [],
    };
  }
}
